<template>
  <div>
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'dashboard-1' }">
        Dashboard
      </b-breadcrumb-item>
      <b-breadcrumb-item active> แก้ไขข้อมูลร้านค้า </b-breadcrumb-item>
    </b-breadcrumb>

    <b-card>
      <b-tabs pills>
        <!-- Tab: Account -->
        <b-tab active>
          <template #title>
            <feather-icon icon="UserIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">บัญชีการใช้งาน</span>
          </template>

          <div>
            <!-- Media -->
            <b-media class="mb-2">
              <template #aside>
                <b-avatar
                  ref="previewEl"
                  :src="shopModel.avatar"
                  size="90px"
                  rounded
                />
              </template>
              <h4 class="mb-1">
                {{ shopModel.shopName }}
              </h4>
              <div class="d-flex flex-wrap">
                <b-button variant="primary" @click="$refs.refInputEl.click()">
                  <input
                    ref="refInputEl"
                    type="file"
                    class="d-none"
                    @input="inputImageRenderer"
                  />
                  <span class="d-none d-sm-inline">Upload</span>
                  <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
                </b-button>
                <b-button variant="outline-secondary" class="ml-1">
                  <span class="d-none d-sm-inline">Remove</span>
                  <feather-icon icon="TrashIcon" class="d-inline d-sm-none" />
                </b-button>
              </div>
            </b-media>

            <!-- Header: Personal Info -->
            <!-- <div class="d-flex">
              <feather-icon
                icon="UserIcon"
                size="19"
              />
              <h4 class="mb-0 ml-50">
                ข้อมูลส่วนตัว
              </h4>
            </div> -->

            <!-- User Info: Input Fields -->
            <!-- <b-form class="mt-1">
              <b-row>
                <b-col cols="12" md="4">
                  <b-form-group
                    label="เลขบัตรประจำตัวประชาชน"
                    label-for="idCardNumber"
                  >
                    <b-form-input
                      id="idCardNumber"
                      v-model="shopModel.idCardNumber"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="Username" label-for="userName">
                    <b-form-input id="userName" v-model="shopModel.userName" />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="Password" label-for="password">
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="password"
                        v-model="shopModel.password"
                        class="form-control-merge"
                        :type="passwordFieldType"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="คำนำหน้านาม" label-for="titleName">
                    <v-select
                      v-model="shopModel.titleName"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="titleOptions"
                      :reduce="(val) => val.value"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="ชื่อ" label-for="firstName">
                    <b-form-input
                      id="firstName"
                      v-model="shopModel.firstName"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="นามสกุล" label-for="lastName">
                    <b-form-input id="lastName" v-model="shopModel.lastName" />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="เพศ" label-for="gender">
                    <v-select
                      v-model="shopModel.gender"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="genderOptions"
                      :reduce="(val) => val.value"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group label="ชื่อเล่น" label-for="nickName">
                    <b-form-input id="nickName" v-model="shopModel.nickName" />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="4">
                  <b-form-group
                    label="วัน/ เดือน/ ปี เกิด"
                    label-for="birthDate"
                  >
                    <b-form-datepicker
                      id="birthDate"
                      v-model="shopModel.birthDate"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      locale="en"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form> -->
          </div>
        </b-tab>

        <!-- Tab: Information -->
        <b-tab>
          <template #title>
            <feather-icon icon="MapPinIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">ข้อมูลการติดต่อ</span>
          </template>
          <div>
            <!-- Media -->
            <b-media class="mb-2">
              <template #aside>
                <b-avatar
                  ref="previewEl"
                  :src="shopModel.avatar"
                  size="90px"
                  rounded
                />
              </template>
              <h4 class="mb-1">
                {{ shopModel.shopName }}
              </h4>
            </b-media>

            <!-- Header: Personal Info -->
            <div class="d-flex">
              <feather-icon icon="MapPinIcon" size="19" />
              <h4 class="mb-0 ml-50">ข้อมูลการติดต่อ</h4>
            </div>

            <!-- Form: Personal Info Form -->
            <b-form class="mt-1">
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group label="เบอร์โทรศัพท์" label-for="phone">
                    <b-form-input id="phone" v-model="shopModel.phone" />
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group label="อีเมล" label-for="email">
                    <b-form-input
                      id="email"
                      v-model="shopModel.email"
                      type="email"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <!-- <b-col>
                  <b-form-group label="ที่อยู่" label-for="address">
                    <b-form-input id="address" v-model="shopModel.address" />
                  </b-form-group>
                </b-col> -->

                <!-- <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="Sub District"
                    label-for="subDistrict"
                  >
                    <v-select
                      v-model="shopModel.subDistrict"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="subDistrictOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="District"
                    label-for="district"
                  >
                    <v-select
                      v-model="shopModel.district"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="districtOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="Province"
                    label-for="province"
                  >
                    <v-select
                      v-model="shopModel.province"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="provinceOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label="Zip Code"
                    label-for="zipCode"
                  >
                    <b-form-input
                      id="zipCode"
                      v-model="shopModel.zipCode"
                    />
                  </b-form-group>
                </b-col> -->
              </b-row>

              <!-- <hr>
              <contact-address-list :user-address-list="userData.addressInformation" /> -->
            </b-form>
          </div>
        </b-tab>
      </b-tabs>

      <b-card-footer class="d-flex align-items-center justify-content-end">
        <b-button
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        >
          Save Changes
        </b-button>
        <b-button
          :to="{ name: 'shop-view' }"
          variant="outline-secondary"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        >
          Cancel
        </b-button>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BAlert,
  BLink,
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BForm,
  BTable,
  BCardHeader,
  BCardTitle,
  BCardFooter,
  BFormCheckbox,
  BFormDatepicker,
  BFormRadioGroup,
  BBreadcrumb,
  BBreadcrumbItem,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import { getUserData } from "@/auth/utils";
import vSelect from "vue-select";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import router from "@/router";
import store from "@/store";
import shopStoreModule from "./shopStoreModule";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BForm,
    vSelect,
    BBreadcrumb,
    BBreadcrumbItem,
    // BTable,
    // BCardHeader,
    // BCardTitle,
    BCardFooter,
    // BFormCheckbox,
    BFormDatepicker,
    // BFormRadioGroup,
    // BLink,
  },
  mixins: [togglePasswordVisibility],
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  setup() {
    const userData = getUserData();

    // Register module
    if (!store.hasModule("shop")) store.registerModule("shop", shopStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule("shop")) store.unregisterModule("shop");
    });

    const titleOptions = [
      { label: "นาย", value: "นาย" },
      { label: "นาง", value: "นาง" },
      { label: "นางสาว", value: "นางสาว" },
    ];

    const genderOptions = [
      { label: "ชาย", value: "ชาย" },
      { label: "หญิง", value: "หญิง" },
    ];

    const shopModel = ref(null);
    // const shopModel = {
    //   id: '',
    //   // eslint-disable-next-line global-require
    //   avatar: require('@/assets/images/slider/07.jpg'),
    //   name: 'ร้านตลาดนัดขนส่ง จำกัด',
    //   userName: '',
    //   password: 'xxxxx',
    //   firstName: '',
    //   lastName: '',
    //   idCardNumber: '',
    //   employeeId: '',
    //   phone: '',
    //   email: '',
    //   addressDetail: '',
    //   status: '',
    // }

    store
      .dispatch("shop/getShop", { id: userData.contactId })
      .then((response) => {
        console.log("response", response);

        shopModel.value = {
          shopName: response.data.shopName,
          contactId: response.data.contactId,
          // eslint-disable-next-line global-require
          avatar: require("@/assets/images/slider/07.jpg"),
          userName: response.data.userName,
          password: response.data.password,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          phone: response.data.phone,
          email: response.data.email,
          birthDate: response.data.birthDate,
          sex: "",
          address: "",
          idCardNumber: "",
          titleName: response.data.title,
          gender: "",
          nickName: "",
        };
      })
      .catch((error) => {});

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        // eslint-disable-next-line no-param-reassign
        shopModel.value.avatar = base64;
      }
    );

    return {
      shopModel,
      titleOptions,
      genderOptions,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
